import { useEffect, useRef, useState } from 'react';

import { Outlet, useLocation, useNavigate, useSearchParams } from 'react-router-dom';

import { useHomeCorausel } from 'api/dashboardApi';

import MineAndRepair from '../MineAndRepair/MineAndRepair';

import CardStack from './CardStack';
import {
  groupByOrderNoAndSortByMiningQuantity,
  groupByOrderNoAndSortByMiningQuantityandId,
  upsertAllItemsCrafted,
  upsertAllItemsUpdate,
  upsertCardUpdate,
  upsertCraftedCard,
} from './helper';

import './style.scss';
import { GAME } from 'constants/routes';

const MainContent = ({ bgImage, toggleModal }) => {
  const { data: { data: { data: cardsList = [] } = {} } = {} } = useHomeCorausel();
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const orderNo = searchParams.get('orderNo');

  const [sortedCards, setSortedCards] = useState([]);
  const [active, setActive] = useState([]);
  const urlInitialisedRef = useRef(false);

  useEffect(() => {
    if (!cardsList.length) return;
    setSortedCards(groupByOrderNoAndSortByMiningQuantity(cardsList));
  }, [cardsList]);

  // On hard refresh: once cards load, restore active state from URL params
  useEffect(() => {
    if (!sortedCards.length || !orderNo || urlInitialisedRef.current) return;
    urlInitialisedRef.current = true;
    const batch = searchParams.get('batch');
    const newSorted = groupByOrderNoAndSortByMiningQuantityandId(sortedCards, orderNo, batch);
    setSortedCards(newSorted);
    setActive(newSorted?.[orderNo - 1]?.items ?? []);
  }, [sortedCards, orderNo, searchParams]);

  const handleNavigate = (data) => {
    const { orderNo: clickedOrderNo, batch: clickedBatch } = data;
    const newSorted = groupByOrderNoAndSortByMiningQuantityandId(sortedCards, clickedOrderNo, clickedBatch);
    setSortedCards(newSorted);
    setActive(newSorted?.[clickedOrderNo - 1]?.items ?? []);
    if (!location.pathname.includes(GAME)) {
      navigate(`${GAME}?orderNo=${clickedOrderNo}&batch=${clickedBatch}`);
    } else {
      setSearchParams({ orderNo: clickedOrderNo, batch: clickedBatch });
    }
  };

  useEffect(() => {
    if (!location.pathname.includes(GAME)) setActive([]);
  }, [location.pathname]);

  const [allItems, setAllItems] = useState([]);

  useEffect(() => {
    if (sortedCards?.length) {
      setAllItems(sortedCards.flatMap((group) => group?.items ?? []));
    }
  }, [sortedCards]);

  const onCardUpdate = (updatedCard) => {
    const updated = updatedCard.data;
    setSortedCards((prev) => upsertCardUpdate(prev, updated));
    setAllItems((prev) => upsertAllItemsUpdate(prev, updated));
  };

  const onCraftSuccess = (updatedCard) => {
    if (!updatedCard) return;
    const updated = updatedCard.data;
    setSortedCards((prev) => upsertCraftedCard(prev, updated));
    setAllItems((prev) => upsertAllItemsCrafted(prev, updated));
  };

  const gameContentStyle = { backgroundImage: `url(${bgImage})` };

  return (
    <div className="main-game">
      <div className="card-container">
        <CardStack items={sortedCards?.[0]?.items} onClick={handleNavigate} />
        <CardStack items={sortedCards?.[2]?.items} onClick={handleNavigate} />
      </div>

      {/* Main Game Area */}
      {!location.pathname.includes(GAME) && !active?.length ? (
        <div className="game-content" style={gameContentStyle}>
          <Outlet context={{ onCraftSuccess, onCardUpdate, toggleModal }} />
        </div>
      ) : null}
      {active?.length && orderNo ? (
        <div className="game-content" style={gameContentStyle}>
          <MineAndRepair
            items={allItems}
            onCardSelect={(card) => setSearchParams({ orderNo: card.orderNo, batch: card.batch })}
            onCardUpdate={onCardUpdate}
            toggleModal={toggleModal}
          />
        </div>
      ) : null}

      {/* Right Cards */}
      <div className="card-container">
        <CardStack items={sortedCards?.[1]?.items} onClick={handleNavigate} />
        <CardStack items={sortedCards?.[3]?.items} onClick={handleNavigate} />
      </div>
    </div>
  );
};

export default MainContent;
